import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Tooltip } from "react-tooltip";
import { convertirFecha } from "utils/generalFunctions";

const PdfButton = ({ data, titleProps, headers, properties, name }) => {
  const exportarPDF = (data) => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(12);

    const title = titleProps;
    let data_export = [];
    data.forEach((element) => {
      let array = [];
      // debugger;
      //Estas comprobaciones son para saber si se trata de la tabla Producción Periodo, lista de inversores (Que son tablas especiales) o una tabla normal
      if (element.paramDiario) {
        element.datos.forEach((dato) => {
          let array = [];
          array.push(
            element.instalacion,
            element.titular,
            dato.nombre,
            `(${dato.fechaInicial})${dato.valorInicial}-${dato.valorFinal}(${dato.fechaFinal})`,
            `${dato.valorFinal} KWh`
          );
          data_export.push(array);
        });

        let array = [];
        array.push(
          `Parametro Diario ${element.paramDiario}`,
          `Pot pico ${element.potPico}`,
          ` `,
          ` `,
          `${Math.abs(element.totalInstalacion)}`
        );
        data_export.push(array);
      } else if (element.datos) {
        element.datos.forEach((dato) => {
          let array = [];
          properties.forEach((prop) => {
            array.push(dato[prop]);
          });
          data_export.push(array);
        });
      } else {
        properties.forEach((prop) => {
          array.push(element[prop]);
        });
        data_export.push(array);
      }
    });

    let content = {
      startY: 70,
      head: headers,
      body: data_export,
      // headStyles: { fillColor: [212, 208, 208] },
      theme: "plain",
      alternateRowStyles: { fillColor: [255, 238, 186] }, // Establecer el color de fondo para las filas pares
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save(`${name}`);
  };
  return (
    <>
      <button
        data-tooltip-id="pdf-tooltip"
        data-tooltip-content="Exportar en PDF"
        className="border-0 bg-danger rounded  mr-1 ml-1"
        onClick={() => exportarPDF(data)}
      >
        <span className="mdi mdi-file-pdf text-white"></span>
      </button>

      <Tooltip id="pdf-tooltip" />
    </>
  );
};

export default PdfButton;
